// URL builders for the surfaces that show one ad. Centralized so a future
// basename change is a single edit — the app router mounts under `/builder`
// (see components/router/router.tsx).

// The review surface for one packet, optionally opened on a particular ad. The
// route is `/:businessID/sprint-packets/:packetID/review` under the same
// `/builder` basename; `?ad=` is read there once the packet's ads have loaded.
// One builder so every host that links to an ad in a packet produces the same
// URL. The packet editor's cards do.
export const packetReviewUrl = (
  businessID: string | number,
  packetID: string | number,
  creativeID?: string | number
): string => {
  const url = `${window.location.origin}/builder/${businessID}/sprint-packets/${packetID}/review`
  return creativeID === undefined ? url : `${url}?ad=${creativeID}`
}

// The review surface opened on its rejected ads rather than on one ad — the route
// out of a client rejection, taken from the draft-campaign launcher and from the
// campaign picker. Which rejected ad to open first is the reviewer's call, so this
// carries the bucket and not an `?ad=`.
export const packetRejectionsUrl = (
  businessID: string | number,
  packetID: string | number
): string => `${packetReviewUrl(businessID, packetID)}?filter=rejected`

// The review surface opened on one ad AND on one of its comments — the employee
// destination for a creative comment, since the review modal's history column
// shows the comment beside the ad it is about. Carries the ad the modal opens on
// plus the shared `commentId`/`anchorType`/`anchorId` contract every other comment
// deep link uses, so the destination can tell an ad link from a comment link.
export const packetReviewCommentUrl = (
  businessID: number,
  packetID: string | number,
  creativeID: string | number,
  commentId: number
): string => {
  const url = new URL(packetReviewUrl(businessID, packetID, creativeID))
  url.search = new URLSearchParams({
    ad: String(creativeID),
    commentId: String(commentId),
    anchorType: 'creative',
    anchorId: String(creativeID),
  }).toString()
  return url.toString()
}
